import { Loader2 } from '../../icons';
import * as React from 'react';

interface LoadingSpinnerProps {
  /** When true, centres the spinner in the full viewport. */
  fullPage?: boolean;
  size?: number;
  className?: string;
}

export function LoadingSpinner({ fullPage = false, size = 24, className = '' }: LoadingSpinnerProps) {
  const spinner = (
    <Loader2
      size={size}
      aria-hidden="true"
      className={`motion-safe:animate-spin text-muted-foreground ${className}`}
    />
  );
  if (fullPage) {
    return (
      <div role="status" aria-label="Loading" className="flex min-h-screen items-center justify-center">
        {spinner}
      </div>
    );
  }
  return (
    <div role="status" aria-label="Loading" className="flex items-center justify-center">
      {spinner}
    </div>
  );
}
